import { createSlice } from '@reduxjs/toolkit';

export const testResultsSlice = createSlice({
  name: 'testResults',
  initialState: {
    originalTestResults: [],
    currentTestResults: [],
    filters: [
      {
        name: 'application',
        value: [],
        data: null,
      },
      {
        name: 'client',
        value: [],
        data: null,
      },
      {
        name: 'template',
        value: [],
        data: null,
      },
      {
        name: 'siteEdition',
        value: [],
        data: null,
      },
      {
        name: 'status',
        value: [],
        data: null,
      },
      {
        name: 'component',
        value: [],
        data: null,
      },
    ],
    execution: {
      status: null,
      userOwnsTest: false,
      consecutiveFails: 0,
      exists: true,
    },
  },
  reducers: {
    setOriginalTestResults: (state, action) => {
      state.originalTestResults = action.payload;
    },
    setCurrentTestResults: (state, action) => {
      state.currentTestResults = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setExecutionStatus: (state, action) => {
      state.execution.status = action.payload;
    },
    setExecutionUserOwnsTest: (state, action) => {
      state.execution.userOwnsTest = action.payload;
    },
    setExecutionConsecutiveFails: (state, action) => {
      state.execution.consecutiveFails = action.payload;
    },
    setExecutionExists: (state, action) => {
      state.execution.exists = action.payload;
    },
  },
});

export const {
  setFilters,
  setOriginalTestResults,
  setCurrentTestResults,
  setExecutionStatus,
  setExecutionUserOwnsTest,
  setExecutionConsecutiveFails,
  setExecutionExists,
} = testResultsSlice.actions;

export default testResultsSlice.reducer;
